import {
  MinimalUserContactSchema,
  PagedMinimalUserContactSchema,
} from "@/api/client";
import { defineStore } from "pinia";
interface ContactState {
  savedContacts?: PagedMinimalUserContactSchema | null;
  allContacts: MinimalUserContactSchema[];
  callQueueId?: number | null;
  computedContactsList: MinimalUserContactSchema[];
  loadingContacts: boolean;
  selectedContact?: MinimalUserContactSchema | null;
  selectedContacts: MinimalUserContactSchema[];
  totalContacts: number;
  selectedContactAndColor?: {
    gradColors: {
      color1: string;
      color2: string;
    };
    contact: MinimalUserContactSchema;
  };
  showContactDetailsModal: boolean;
  cachedSavedContactList: MinimalUserContactSchema[];
}

export const useContactStore = defineStore("contact", {
  state: (): ContactState => ({
    savedContacts: null,
    allContacts: [],
    callQueueId: null,
    computedContactsList: [],
    loadingContacts: false,
    selectedContact: null,
    selectedContacts: [],
    totalContacts: 0,
    showContactDetailsModal: false,
    cachedSavedContactList: [],
  }),
  getters: {
    selectedContactIDs: (state: ContactState) => {
      const selectedIDs = [];
      for (let i = 0; i < state.selectedContacts.length; i++) {
        selectedIDs.push(state.selectedContacts[i]?.id); // Assuming each selected contact has an "id" property
      }
      return selectedIDs;
    },
  },
});
